import React from 'react'
import PropTypes from 'prop-types'
import { generatePath, useNavigate, useParams } from 'react-router-dom'

import Tabs from '~/components/Tabs'
import { SUPPLIER_UPDATE_PATH } from '~/constants/routes'
import { SUPPLIER_UPDATE_TABS } from '~/constants/tabs'

const tabs = [
  { value: SUPPLIER_UPDATE_TABS.GENERAL, label: 'General' },
  { value: SUPPLIER_UPDATE_TABS.ADDRESS, label: 'Address' },
  { value: SUPPLIER_UPDATE_TABS.BANK_ACCOUNT, label: 'Bank account' }
]

function SupplierUpdateFormTabs ({ value }) {
  const navigate = useNavigate()
  const { guid } = useParams()
  const onChange = (event, tab) => {
    const redirect = generatePath(SUPPLIER_UPDATE_PATH, { guid, tab })

    navigate(redirect, { replace: true })
  }

  return (
    <Tabs
      tabs={tabs}
      value={value}
      onChange={onChange}
    />
  )
}

SupplierUpdateFormTabs.propTypes = {
  value: PropTypes.string.isRequired
}

export default SupplierUpdateFormTabs
